import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';
import { Link } from 'react-router-dom';

import { Col, Row, Statistic, Spin } from 'antd';
import { Card } from 'react-bootstrap';

import SummaryBoardActions from '../../Stores/SummaryBoard/Actions';
import './SummaryBoardStyle.css';

class LoadListSummaryCard extends React.PureComponent {
  componentDidMount() {
    const {
      resetTimestampPending,
      resetTimestampWip,
      resetTimestampWhseJobs,
      resetTimestampCompleted
    } = this.props;

    const { curSiteFlowId } = this.props;

    if (curSiteFlowId > 0) {
      resetTimestampPending();
      resetTimestampWip();
      resetTimestampWhseJobs();
      resetTimestampCompleted();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      curSiteFlowId,
      fetchSummaryPending,
      fetchSummaryWip,
      fetchSummaryWhseJobs,
      fetchSummaryCompleted
    } = this.props;

    const {
      resetTimestampPending,
      resetTimestampWip,
      resetTimestampWhseJobs,
      resetTimestampCompleted
    } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      resetTimestampPending();
      resetTimestampWip();
      resetTimestampWhseJobs();
      resetTimestampCompleted();
    }

    if (changed('summaryPendingTimestamp')) {
      if (curSiteFlowId > 0) {
        fetchSummaryPending();
      }
    }

    if (changed('summaryWipTimestamp')) {
      if (curSiteFlowId > 0) {
        fetchSummaryWip();
      }
    }

    if (changed('summaryWhseJobsTimestamp')) {
      if (curSiteFlowId > 0) {
        fetchSummaryWhseJobs();
      }
    }

    if (changed('summaryCompletedTimestamp')) {
      if (curSiteFlowId > 0) {
        fetchSummaryCompleted();
      }
    }
  }

  render() {
    const { summaryPending, summaryWip, summaryWhseJobs, summaryCompleted } = this.props;

    const { intl } = this.props;

    const {
      summaryPendingIsLoading,
      summaryWipIsLoading,
      summaryWhseJobsIsLoading,
      summaryCompletedIsLoading
    } = this.props;

    return (
      <Link to="/loadListDetailBoard" style={{ textDecoration: 'none' }}>
        <Card className="summary-card" text="dark">
          <Card.Header className="load-list-header">
            {intl.formatMessage({ id: 'load_list_summary' })}
          </Card.Header>
          <Row>
            <Col span={12} style={summaryPendingIsLoading ? { paddingTop: '10%' } : {}}>
              <Card.Body>
                {summaryPendingIsLoading ? (
                  <Spin />
                ) : (
                  <div>
                    <Statistic
                      title={intl.formatMessage({ id: 'pending' })}
                      value={summaryPending.total}
                    />
                    <div style={{ color: 'red' }}>{summaryPending.date_oldest}</div>
                  </div>
                )}
              </Card.Body>
            </Col>
            <Col span={12} style={summaryWipIsLoading ? { paddingTop: '10%' } : {}}>
              <Card.Body>
                {summaryWipIsLoading ? (
                  <Spin />
                ) : (
                  <div>
                    <Statistic title={intl.formatMessage({ id: 'WIP' })} value={summaryWip.total} />
                    <div style={{ color: 'red' }}>{summaryWip.date_oldest}</div>
                  </div>
                )}
              </Card.Body>
            </Col>
            <Col span={12} style={summaryWhseJobsIsLoading ? { paddingBottom: '10%' } : {}}>
              <Card.Body>
                {summaryWhseJobsIsLoading ? (
                  <Spin />
                ) : (
                  <div>
                    <Statistic
                      title={intl.formatMessage({ id: 'mobile_jobs' })}
                      value={summaryWhseJobs.total}
                    />
                    <div style={{ color: 'red' }}>{summaryWhseJobs.date_oldest}</div>
                  </div>
                )}
              </Card.Body>
            </Col>
            <Col span={12} style={summaryCompletedIsLoading ? { paddingBottom: '10%' } : {}}>
              <Card.Body>
                {summaryCompletedIsLoading ? (
                  <Spin />
                ) : (
                  <div>
                    <Statistic
                      title={intl.formatMessage({ id: 'completed' })}
                      value={summaryCompleted.total}
                    />
                    <div style={{ color: 'red' }}>{summaryCompleted.date_oldest}</div>
                  </div>
                )}
              </Card.Body>
            </Col>
          </Row>
        </Card>
      </Link>
    );
  }
}

LoadListSummaryCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,

  // eslint-disable-next-line react/forbid-prop-types
  summaryPending: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  summaryWip: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  summaryWhseJobs: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  summaryCompleted: PropTypes.object,

  summaryPendingIsLoading: PropTypes.bool,
  summaryWipIsLoading: PropTypes.bool,
  summaryWhseJobsIsLoading: PropTypes.bool,
  summaryCompletedIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchSummaryPending: PropTypes.func,
  fetchSummaryWip: PropTypes.func,
  fetchSummaryWhseJobs: PropTypes.func,
  fetchSummaryCompleted: PropTypes.func,

  resetTimestampPending: PropTypes.func,
  resetTimestampWip: PropTypes.func,
  resetTimestampWhseJobs: PropTypes.func,
  resetTimestampCompleted: PropTypes.func
};

LoadListSummaryCard.defaultProps = {
  intl: {},

  summaryPending: { total: 0, date_oldest: '0 days' },
  summaryWip: { total: 0, date_oldest: '0 days' },
  summaryWhseJobs: { total: 0, date_oldest: '0 days' },
  summaryCompleted: { total: 0, date_oldest: '0 days' },

  summaryPendingIsLoading: false,
  summaryWipIsLoading: false,
  summaryWhseJobsIsLoading: false,
  summaryCompletedIsLoading: false,

  curSiteFlowId: 0,
  fetchSummaryPending() {},
  fetchSummaryWip() {},
  fetchSummaryWhseJobs() {},
  fetchSummaryCompleted() {},

  resetTimestampPending() {},
  resetTimestampWip() {},
  resetTimestampWhseJobs() {},
  resetTimestampCompleted() {}
};

const mapStateToProps = state => ({
  summaryPendingTimestamp: state.summaryBoard.loadListSummaryPendingTimestamp,
  summaryPending: state.summaryBoard.loadListSummaryPending,

  summaryWipTimestamp: state.summaryBoard.loadListSummaryWipTimestamp,
  summaryWip: state.summaryBoard.loadListSummaryWip,

  summaryWhseJobsTimestamp: state.summaryBoard.loadListSummaryWhseJobsTimestamp,
  summaryWhseJobs: state.summaryBoard.loadListSummaryWhseJobs,

  summaryCompletedTimestamp: state.summaryBoard.loadListSummaryCompletedTimestamp,
  summaryCompleted: state.summaryBoard.loadListSummaryCompleted,

  summaryPendingIsLoading: state.summaryBoard.loadListSummaryPendingIsLoading,
  summaryWipIsLoading: state.summaryBoard.loadListSummaryWipIsLoading,
  summaryWhseJobsIsLoading: state.summaryBoard.loadListSummaryWhseJobsIsLoading,
  summaryCompletedIsLoading: state.summaryBoard.loadListSummaryCompletedIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  resetTimestampPending: () =>
    dispatch(SummaryBoardActions.loadListSummaryBoardResetPendingTimestamp()),

  fetchSummaryPending: () => dispatch(SummaryBoardActions.loadListSummaryBoardFetchPending()),

  resetTimestampWip: () => dispatch(SummaryBoardActions.loadListSummaryBoardResetWipTimestamp()),

  fetchSummaryWip: () => dispatch(SummaryBoardActions.loadListSummaryBoardFetchWip()),

  resetTimestampWhseJobs: () =>
    dispatch(SummaryBoardActions.loadListSummaryBoardResetWhseJobsTimestamp()),

  fetchSummaryWhseJobs: () => dispatch(SummaryBoardActions.loadListSummaryBoardFetchWhseJobs()),

  resetTimestampCompleted: () =>
    dispatch(SummaryBoardActions.loadListSummaryBoardResetCompletedTimestamp()),

  fetchSummaryCompleted: () => dispatch(SummaryBoardActions.loadListSummaryBoardFetchCompleted())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(LoadListSummaryCard));
